import React from "react";

function PlayerTable({ players }) {
  return (
    <div className="table-container">
      <h2> Tournament Participants</h2>
      <table>
        <thead>
          <tr>
            <th>Gamer Tag</th>
            <th>Department</th>
            <th>Game</th>
            <th>Rank</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player) => (
            <tr key={player.id}>
              <td>{player.gamerTag}</td>
              <td>{player.department}</td>
              <td>{player.game}</td>
              <td>{player.rank}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlayerTable;